
define(function (require) {
	var getLabel = function (ele, asText, detailOptions) {
		var el = $('<span/>', {
			class: 'detail-label',
			name: ele.bind,
			showashtml:ele.isHtml === true
		});

		if (ele.isHtml) {
			el.html(Handlebars.helpers['global:sanitize'](ele.text));
		}
		else {
			el.text(ele.text);
		}

		return el;
	};
	return {
		getLabel: function (ele, asText, detailOptions) {
			return getLabel(ele, asText, detailOptions);
		}
	}
});